<template>
    <div id="paginated-package-messages-overview-component" class="row">
        <div class="col-md-12">
            <div class="panel panel-default panel-stretch">
                <div class="panel-heading">
                    <span v-if="afdMessageCount" class="badge pull-right red-background">{{ afdMessageCount }}</span>
                    Pakket berichten
                </div>
                <div class="panel-body no-padding">
                    <div class="panel-body">
                        <laravel-pagination
                            v-if="displayPagination"
                            :data="currentRequestData"
                            style="margin: 0;vertical-align: middle; margin-top: -4px; margin-right: 1.5rem;"
                            @pagination-change-page="onChangePage"
                        ></laravel-pagination>

                        Per pagina
                        <a-select :default-value="perPage" @change="onChangePerPage">
                            <a-select-option v-for="(value, key) in perPageOptions" :key="key" :value="value">
                                {{ value }}
                            </a-select-option>
                        </a-select>

                        <afd-message-filter-component :filter-agencies="true"
                                                      :filter-customer="true"
                                                      :filter-date-range="true"
                                                      :disable-filters="loading"
                                                      :initial-filters="getPackageMessageFilters"
                                                      @filter="filterAfdMessages($event)"></afd-message-filter-component>

                        <div class="pull-right">
                            <a-dropdown class="actions" :trigger="['click']" @click.stop placement="bottomRight"
                                        :disabled="!hasSelection">
                                <a-button type="default" @click.stop="e => e.preventDefault()">
                                    Acties
                                    <a-icon type="down"/>
                                </a-button>

                                <a-menu slot="overlay">
                                    <a-menu-item key="reject" class="action-reject btn-primary">
                                        <a-popconfirm
                                            cancel-text="Annuleren"
                                            ok-text="Afkeuren"
                                            placement="topRight"
                                            title="Weet je zeker dat je deze berichten wilt markeren als voltooid?"
                                            @confirm="onRejectSelectedMessages">
                                            <close-icon/>
                                            Afkeuren ({{ this.selectedAfdMessages.length }})
                                        </a-popconfirm>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </div>
                    </div>
                    <table v-if="hasAfdMessages" class="table table-striped">
                        <thead>
                        <tr>
                            <th class="compact half-padding">
                                <a-checkbox ref="globalCheckbox" :checked="allSelected" :indeterminate="indeterminate"
                                            @change="onChangeSelectAll"></a-checkbox>
                            </th>
                            <th class="compact">
                                <order-by :order="order" :select="orderBy" value="message_id" @change="onChangeOrderBy"
                                          class="compact"> Bericht ID
                                </order-by>
                            </th>
                            <th class="compact">
                                <order-by :order="order" :select="orderBy" value="customer" @change="onChangeOrderBy"
                                          class="compact"> Klant
                                </order-by>
                            </th>
                            <th>Omschrijving</th>
                            <th class="compact">
                                <order-by :order="order" :select="orderBy" value="agency" @change="onChangeOrderBy"
                                          class="compact"> Maatschappij
                                </order-by>
                            </th>
                            <th class="compact">
                                <order-by :order="order" :select="orderBy" value="datetime" @change="onChangeOrderBy"
                                          class="compact"> Datum bericht
                                </order-by>
                            </th>
                            <th class="compact">
                                <order-by :order="order" :select="orderBy" value="package_number"
                                          @change="onChangeOrderBy"
                                          class="compact"> Pakketnummer
                                </order-by>
                            </th>
                            <th class="compact">Gekoppeld Pakket</th>
                            <th class="compact"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <package-message-row-component
                            v-for="afdMessage in afdMessages" :key="afdMessage.id"
                            :afd-message="afdMessage" @onChangeSelect="onChangeSelect">
                        </package-message-row-component>
                        </tbody>
                    </table>
                    <div v-else class="panel-body"> Er zijn geen pakket berichten.</div>
                    <div class="panel-body" style="padding-top: 0;">
                        <laravel-pagination
                            v-if="displayPagination"
                            :data="currentRequestData"
                            style="margin: 0;"
                            @pagination-change-page="onChangePage"
                        ></laravel-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AfdMessageFilterComponent from "./AFDMessageFilterComponent.vue";
import PackageMessageRowComponent from "./PackageMessageRowComponent.vue";
import store from "../store";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "PaginatedPackageMessagesOverviewComponent",
    components: {
        AfdMessageFilterComponent,
        PackageMessageRowComponent
    },
    data() {
        return {
            allSelected: false,
        };
    },
    computed: {
        ...mapGetters({
            afdMessageCount: "$_sivi/unprocessedPackageMessageCount",
            afdMessages: "$_sivi/paginatedUnprocessedPackageMessages",
            currentRequestData: "$_sivi/paginatedUnprocessedPackageMessagesCurrentRequestData",
            hasAfdMessages: "$_sivi/hasPaginatedUnprocessedPackageMessages",
            loading: "$_sivi/fetchingPaginatedUnprocessedPackageMessages",
            order: "$_sivi/paginatedUnprocessedPackageMessagesOrder",
            orderBy: "$_sivi/paginatedUnprocessedPackageMessagesOrderBy",
            page: "$_sivi/paginatedUnprocessedPackageMessagesPage",
            perPage: "$_sivi/paginatedUnprocessedPackageMessagesPerPage",
            perPageOptions: "$_sivi/perPageOptions",
            selectedAfdMessages: "$_sivi/selectedUnprocessedPackageMessages",
            getPackageMessageFilters: "$_sivi/getPackageMessageFilters",
        }),
        currentSelectionDiff() {
            return this.afdMessages.filter(i => this.selectedAfdMessages.findIndex(x => x.id === i.id) < 0).length;
        },
        displayPagination() {
            return typeof this.currentRequestData.meta !== "undefined";
        },
        hasSelection() {
            return this.selectedAfdMessages.length > 0;
        },
        indeterminate() {
            return this.allSelected === false
                && this.currentSelectionDiff !== this.afdMessages.length
                && this.currentSelectionDiff > 0;
        },
    },
    methods: {
        ...mapActions({
            fetchUnprocessedPackageMessages: "$_sivi/fetchPaginatedUnprocessedPackageMessages",
            rejectAfdMessages: "$_sivi/rejectUnprocessedPackageMessages",
            setOrder: "$_sivi/setPaginatedUnprocessedPackageMessagesOrder",
            setOrderBy: "$_sivi/setPaginatedUnprocessedPackageMessagesOrderBy",
            setPage: "$_sivi/setPaginatedUnprocessedPackageMessagesPage",
            setPerPage: "$_sivi/setPaginatedUnprocessedPackageMessagesPerPage",
            setPackageMessageFilters: "$_sivi/setPackageMessageFilters",
            initialisePackageMessageFilters: "$_sivi/initialisePackageMessageFilters",
        }),
        fetchAfdMessages() {
            this.fetchUnprocessedPackageMessages({
                filters: this.getPackageMessageFilters,
                includes: ["agency"],
                order: this.order,
                orderBy: this.orderBy,
                page: this.page,
                pageName: "packageMessagesPage",
                perPage: this.perPage,
            });
        },
        filterAfdMessages(filters) {
            this.setPackageMessageFilters(filters)
            this.fetchAfdMessages();
        },
        onChangeOrderBy(orderBy, order) {
            this.setOrder(order);
            this.setOrderBy(orderBy);
            this.fetchAfdMessages();
        },
        onChangePage(page) {
            this.setPage(page);
            this.fetchAfdMessages();
        },
        onChangePerPage(perPage) {
            this.setPerPage(perPage);
            this.fetchAfdMessages();
        },
        onChangeSelect(afdMessage, selected) {
            selected === true ? this.selectAfdMessage(afdMessage) : this.deselectAfdMessage(afdMessage);
        },
        onChangeSelectAll() {
            this.allSelected = !this.allSelected;

            for (let i in this.afdMessages) {
                let afdMessage = this.afdMessages[i];

                if (this.allSelected === true && this.selectedAfdMessages.findIndex(x => x.id === afdMessage.id) < 0) {
                    this.selectAfdMessage(afdMessage);
                } else if (this.allSelected === false) {
                    this.deselectAfdMessage(afdMessage);
                }
            }
        },
        selectAfdMessage(afdMessage) {
            this.selectedAfdMessages.push(afdMessage);

            if (this.currentSelectionDiff === 0) {
                this.allSelected = true;
            }
        },
        deselectAfdMessage(afdMessage) {
            this.allSelected = false;

            this.selectedAfdMessages.splice(this.selectedAfdMessages.findIndex(x => x.id === afdMessage.id), 1);
        },
        onRejectSelectedMessages() {
            this.rejectAfdMessages(this.selectedAfdMessages.map((message) => {
                return message.id;
            }))
                .then(() => {
                    this.$notification.success({
                        message: "Gelukt",
                        description: "De geselecteerde berichten zijn gemarkeerd als voltooid",
                    });
                })
                .catch(() => {
                    this.$notification.error({
                        message: "Er ging iets mis",
                        description: "Het is niet gelukt om de berichten af te keuren",
                    });
                });
        },
    },
    created() {
        const STORE_KEY = "$_sivi";
        // eslint-disable-next-line no-underscore-dangle
        if (!(STORE_KEY in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY, store);
        }

        this.initialisePackageMessageFilters();
        this.fetchAfdMessages();
    },
};
</script>

<style scoped>
.red-background {
    background-color: rgb(255, 0, 82) !important;
}
</style>
